import React from 'react';
import { Redirect } from 'react-router-dom';
import {
  IonPage,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonContent,
  IonGrid,
  IonRow,
  IonCol,
  IonCard,
  IonCardContent,
  IonCardHeader,
  IonCardSubtitle,
  IonCardTitle,
  IonButton
} from '@ionic/react';
import { Form, Formik } from 'formik';
import alerts from 'src/lib/alerts';
import Field from 'src/components/Field';
import app from 'src/feathers';
import yup from 'src/feathers/yup';

export default class PasswordReset extends React.Component {
  constructor(props) {
    super(props);
    const { resetToken } = this.props.location.query;
    this.state = {
      // Redirect immediately if no token, user should not be here
      redirect: resetToken ? null : '/forgot-password',
      fetching: false
    };
  }

  handleSubmit = (data, formik) => {
    const { resetToken } = this.props.location.query;
    app
      .service('auth/password-reset')
      .create({ ...data, resetToken })
      .then((user) => {
        return app.authenticate({
          strategy: 'local',
          email: user.email,
          password: data.password
        });
      })
      .then((authentication) => {
        formik.setSubmitting(false);
        this.setState({ redirect: '/' });
      })
      .catch((err) => {
        formik.setSubmitting(false);
        alerts.errors(err.message);
        if (err.errors) {
          formik.setErrors(err.errors);
        }
      });
  };

  render() {
    if (this.state.redirect) {
      return <Redirect to={this.state.redirect} />;
    }
    return (
      <IonPage>
        <IonHeader>
          <IonToolbar>
            <IonTitle>Murphy</IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <IonGrid fixed style={{ height: '100%' }}>
            <IonRow className="align-items-center" style={{ height: '100%' }}>
              <IonCol sizeLg={4} offsetLg={4}>
                <IonCard>
                  <IonCardHeader>
                    <IonCardSubtitle>Reset Password</IonCardSubtitle>
                    <IonCardTitle>Welcome Back!</IonCardTitle>
                  </IonCardHeader>
                  <IonCardContent>
                    <Formik
                      initialValues={{ password: '', confirmPassword: '' }}
                      onSubmit={this.handleSubmit}
                      validationSchema={yup.object({
                        password: yup
                          .trimmedString()
                          .label('Password')
                          .required(),
                        confirmPassword: yup
                          .trimmedString()
                          .label('Confirm Password')
                          .isEqual('password')
                          .required()
                      })}
                      render={({ isSubmitting }) => {
                        return (
                          <Form>
                            <Field
                              type="password"
                              name="password"
                              label="Password"
                              disabled={isSubmitting}
                            />
                            <Field
                              type="password"
                              name="confirmPassword"
                              label="Confirm Password"
                              disabled={isSubmitting}
                            />
                            <IonButton
                              type="submit"
                              color="primary"
                              expand="block"
                              disabled={isSubmitting}
                            >
                              Reset Password
                            </IonButton>
                          </Form>
                        );
                      }}
                    />
                  </IonCardContent>
                </IonCard>
              </IonCol>
            </IonRow>
          </IonGrid>
        </IonContent>
      </IonPage>
    );
  }
}
